/**
 * @typedef {Object} ListenerEntry
 *
 * @property {HTMLElement|Document|Window} element - The element the listener is going to be attached to
 * @property {keyof HTMLElementEventMap|keyof WindowEventHandlersEventMap} event - The event name we want listen for
 * @property {Function} fn - The function that will get run on the event
 */
window.PURELEI.Listeners = class Listeners {
    constructor () {
        /**
         * @type {ListenerEntry[]}
         * @private
         */
        this._entries = []
    }

    /**
     * @param {HTMLElement} element - The element the listener is going to be attached to
     * @param {keyof HTMLElementEventMap} event - The event name we want listen for
     * @param {Function} fn - The function that will get run on the event
     * @param {AddEventListenerOptions | boolean} options - An object that specifies characteristics about the event listener
     */
    add (element, event, fn, options = {}) {
        if(event === 'touchstart') { 
            // console.debug({[event]: element});
            options['passive'] = true;
        }
        this._entries.push({ element, event, fn, options })

        element.addEventListener(event, fn, options)
    }

    /**
     * @param {keyof HTMLElementEventMap} event - The event name we want listen for
     * @param {Function} fn - The function that will get run on the event
     */
    remove (event, fn) {
        const foundListener = this._entries.find(
            (listener) => listener.event === event && listener.fn === fn,
        )

        if (foundListener) {
            this._entries = this._entries.filter(
                (listener) => listener !== foundListener,
            )

            foundListener.element.removeEventListener(
                foundListener.event,
                foundListener.fn,
                foundListener.options,
            )
        }
    }

    /**
     * @returns {undefined}
     */
    removeAll () {
        this._entries = this._entries.filter((listener) => {
            listener.element.removeEventListener(listener.event, listener.fn)

            return false
        })
    }
}
